import { ArrowUpRight, Instagram, Linkedin, Facebook } from "lucide-react";
import { Link } from "react-router-dom";

const COLS = [
  {
    title: "Services",
    links: [
      { label: "Customized Exporting", href: "/services" },
      { label: "Global Logistics", href: "/services" },
      { label: "Customs Clearance", href: "/services" },
      { label: "Yiwu Sourcing", href: "/services" },
      { label: "Travel Assistance", href: "/services" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About", href: "/about" },
      { label: "Gallery", href: "/gallery" },
      { label: "Projects", href: "/projects" },
      { label: "Client Stories", href: "/#stories" },
      { label: "Contact", href: "/contact" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Privacy Policy", href: "#" },
      { label: "Terms & Conditions", href: "#" },
      { label: "Cookie Preferences", href: "#" },
    ],
  },
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-ink text-white pt-20 md:pt-28 overflow-hidden"
    >
      <div className="absolute inset-0 grain opacity-30" aria-hidden />
      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-12">
          <div className="md:col-span-4">
            <Link to="/" className="flex items-center gap-3">
              <img
                src="/logo.png"
                alt="Emporia World"
                className="w-12 h-12 object-contain"
                style={{ filter: "brightness(0) invert(1)" }}
              />
              <span className="font-heading font-black tracking-tighter text-[26px] text-white">
                EMPORIA<span className="text-signal">.</span>
              </span>
            </Link>
            <p className="mt-5 text-white/60 text-[15px] leading-relaxed max-w-sm">
              Your global sourcing partner. Customized exporting, Yiwu sourcing,
              customs clearance and door-to-door logistics — across 15+ countries.
            </p>
            <div className="mt-6 flex items-center gap-3">
              {[Instagram, Linkedin, Facebook].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  data-testid={`footer-social-${i}`}
                  className="w-10 h-10 border border-white/15 flex items-center justify-center hover:border-signal hover:text-signal transition-colors"
                  aria-label="Social"
                >
                  <Icon className="w-4 h-4" strokeWidth={1.6} />
                </a>
              ))}
            </div>
          </div>

          {COLS.map((c) => (
            <div key={c.title} className="md:col-span-2">
              <div className="font-mono text-[11px] uppercase tracking-[0.22em] text-white/50 mb-5">
                {c.title}
              </div>
              <ul className="space-y-3">
                {c.links.map((l) => (
                  <li key={l.label}>
                    <a
                      href={l.href}
                      className="text-white/85 hover:text-signal transition-colors text-[15px] inline-flex items-center gap-1.5 group"
                    >
                      {l.label}
                      <ArrowUpRight className="w-3.5 h-3.5 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all" />
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-2">
            <div className="font-mono text-[11px] uppercase tracking-[0.22em] text-white/50 mb-5">
              Visit
            </div>
            <p className="text-white/85 text-[14px] leading-relaxed">
              402, Wealth Mansion,<br />
              Yiwu, Zhejiang,<br />
              China
            </p>
            <a
              href="mailto:info@emporiaworld.co"
              className="mt-3 inline-block text-white/65 hover:text-signal text-sm transition-colors"
            >
              info@emporiaworld.co
            </a>
            <p className="mt-4 text-white/60 text-sm">
              Mon–Sat · 09:00–17:00
            </p>
          </div>
        </div>

        {/* Giant wordmark + logo watermark */}
        <div className="relative mt-20 md:mt-28 overflow-hidden pointer-events-none select-none" aria-hidden>
          <img
            src="/logo.png"
            alt=""
            className="absolute right-0 -top-10 md:-top-20 w-[260px] md:w-[440px] opacity-[0.06]"
            style={{ filter: "brightness(0) invert(1)" }}
          />
          <div className="font-heading font-black tracking-[-0.05em] leading-none text-white/[0.04] text-[22vw] md:text-[16vw]">
            EMPORIA.
          </div>
        </div>

        <div className="relative border-t border-white/10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-white/50 text-xs md:text-sm">
          <span>© {new Date().getFullYear()} Emporia World. All rights reserved.</span>
          <span className="font-mono uppercase tracking-[0.22em]">Made in Yiwu · For the world</span>
        </div>
      </div>
    </footer>
  );
}
